const translations = {
  placeholder: {
    explore: "Search library...",
    marketplace: "Search marketplace..."
  }
};

export default translations;
